import { __rest } from "tslib";
import React from 'react';
import { assignInlineVars } from '@vanilla-extract/dynamic';
import { cn, mergeProps } from '~/utils';
import { text } from './text.css';
import { lineClampVar } from '~/theme/vars.css';
const TEXT_NAME = 'vulcanui-text';
const Text = React.forwardRef((props, ref) => {
    const { as: Comp = 'p', children, className, color = 'inherit', family: familyProp = 'nunito', maxLines, size, style = {}, textTransform, weight } = props, restProps = __rest(props, ["as", "children", "className", "color", "family", "maxLines", "size", "style", "textTransform", "weight"]);
    const hasMaxLines = maxLines !== undefined;
    const heading = React.useMemo(() => {
        if (typeof Comp !== 'string')
            return 'p';
        const heading = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'].includes(Comp);
        return heading ? Comp : 'p';
    }, [Comp]);
    const family = React.useMemo(() => {
        const shouldUseMono = ['pre', 'code'].includes(Comp);
        return shouldUseMono ? 'robotoMono' : familyProp;
    }, [familyProp, Comp]);
    return (React.createElement(Comp, Object.assign({ className: cn(TEXT_NAME, `${TEXT_NAME}--${Comp}`, className, text({ color, family, size, weight, hasMaxLines, as: heading, textTransform })), style: mergeProps(hasMaxLines ? assignInlineVars({ [lineClampVar]: maxLines.toString() }) : {}, style), ref: ref }, restProps), children));
});
Text.displayName = 'Text';
Text.toString = () => `.${TEXT_NAME}`;
export default Text;
//# sourceMappingURL=text.js.map